import React from 'react';

// 동시 작업 프레즌스 표시 — 목록 행의 "OOO 작업 중" 이름 배지를 대체하는 물결(ripple) 펄스 점.
// (Jin 피드백: 목록에서 이름 배지는 공간만 차지한다 → 점만. 이름은 title/aria-label 로 유지.)
// 단건 편집 화면(드로어/모달) 상단 배너(PresenceBanner.js)는 그대로 — 이 컴포넌트는 목록 배지만 대체한다.
// 행 왼쪽 주황 띠는 2026-09-10 폐기(점이 유일한 목록 표식, Jin).
// keyframes(presenceRipple)·링 의사요소·prefers-reduced-motion 은 전역 App.css 에 있다 (레포 관례: 공용 애니메이션은 App.css).
//
// props
//   users   : [{userId,name,displayName}] — 본인 접속이 제외된 others (utils/carPresence.presenceOthersLabeled).
//             표시 이름은 displayName(같은 계정 다른 기기면 "(PC)"/"(모바일)" 이 붙는다), 없으면 name.
//             비면 렌더하지 않는다 (reserve 면 빈 자리만).
//   label   : '작업 중'(기본) | '수정 중' — title 문구에만 쓰인다.
//   reserve : 목록용 — users 가 비어도 같은 크기의 투명 자리(8px + 여백 6px)를 남긴다.
//             점은 행 맨 앞(차량번호 앞)에 오므로, 자리를 안 잡으면 점이 켜질 때 번호가
//             오른쪽으로 밀려 목록이 흔들린다 (Jin 피드백). 자리엔 애니메이션·title 없음.
//   style   : 추가 인라인 스타일 (기본 위에 덮어씀)

var DOT_STYLE = {
  display: 'inline-block', verticalAlign: 'middle', marginRight: 6,
  width: 8, height: 8, borderRadius: '50%', background: '#f59e0b', flexShrink: 0
};

function PresenceDot(props) {
  var users = props.users || [];
  if (!users.length) {
    if (!props.reserve) return null;
    return (<span className="presence-dot-slot" aria-hidden="true"
      style={Object.assign({}, DOT_STYLE, { background: 'transparent' }, props.style)} />);
  }
  var text = users.map(function(u) { return u.displayName || u.name; }).join(', ') + ' ' + (props.label || '작업 중');
  // 이름이 title/aria-label 에만 있으므로 포커스로도 닿아야 한다 — span 은 기본값이 포커스 불가.
  return (<span className="presence-dot" role="img" tabIndex={0} title={text} aria-label={text}
    style={Object.assign({}, DOT_STYLE, props.style)} />);
}

export default PresenceDot;
